const chartConfig = {
  colors: {
    observation: "#000000",
    rcp26: "#006d97",
    rcp85: "#e50042",
  },
  legend: {
    width: 175,
    size: 12,
  },
  periods: {
    obs: [
      { label: "1881-1910", tickMid: 1852.25 },
      { label: "1891-1920", tickMid: 1866.75 },
      { label: "1901-1930", tickMid: 1881.25 },
      { label: "1911-1940", tickMid: 1895.75 },
      { label: "1921-1950", tickMid: 1910.25 },
      { label: "1931-1960", tickMid: 1924.75 },
      { label: "1941-1970", tickMid: 1939.25 },
      { label: "1951-1980", tickMid: 1953.75 },
      { label: "1961-1990", tickMid: 1968.25 },
      { label: "1971-2000", tickMid: 1982.75 },
      { label: "1981-2010", tickMid: 1998.25 },
      { label: "1991-2020", tickMid: 2012.75 },
    ],
    future: [
      { label: "2031-2060", tickMid: 2045.5 },
      { label: "2071-2100", tickMid: 2065.5 },
    ],
  },
};

export default chartConfig;
